<template>
    <v-dialog v-model="isView">
        <v-card class="mt-3">
            <Title title="画像のタグ設定">
                <v-spacer />
                <TitleButton
                    color="primary"
                    icon="mdi-tag"
                    name="決定"
                    @click="onClickSet" />
                <TitleButton
                    color="primary"
                    icon="mdi-close-circle"
                    name="キャンセル"
                    @click="isView = false" />
            </Title>
            <v-card-text>
                <v-card v-if="targetImage != null" outlined class="mt-2 pa-2">
                    <v-chip v-for="tag in registeredTags" :key="tag" color="teal" text-color="white" class="mr-1 ml-1" close @click:close="onClickDeleteTag(tag)">{{tag}}</v-chip>
                </v-card>
                <v-text-field 
                    class="mt-2"
                    v-model="editTag" 
                    outlined 
                    hint="撮影した画像を後で検索しやすくする為のタグを入力します。(スペースで区切って複数指定出来ます)" 
                    persistent-hint
                    clearable
                    append-icon="mdi-plus-circle-outline"
                    @click:append="onClickAddTag">
                </v-text-field>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        components: {
            Title,
            TitleButton,
        },
        data: function () {
            return {
                isView: false,
                editTag: "",
                registeredTags: [],
                targetImage: null
            }
        },
        methods: {
            onClickDeleteTag: function (tag) {
                this.registeredTags.splice(this.registeredTags.findIndex((v)=>v==tag), 1)
            },
            onClickAddTag: function () {
                const self = this
                const tags = this.editTag.split(" ")
                tags.forEach(function(tag){
                    if (self.registeredTags.findIndex((v)=>v==tag) < 0) {
                        self.registeredTags.push(tag)
                    }
                })
                this.editTag = ""                
            },
            onClickSet: function () {
                const self = this
                const userUID = this.$store.getters["userUID"]
                this.targetImage.tags = this.registeredTags
                this.isView = false
                db.collection("users").doc(userUID).collection("uncategorized_images").doc(this.targetImage.imageID).update({"tags":this.targetImage.tags}).then(function(){
                    self.$store.commit("notification", {message:"タグを登録しました。"})
                }).catch (function(error){
                    self.$store.commit("notification", {message:"タグの登録に失敗しました。", isError:true})
                })
            },
            show: function (image) {
                console.log(image)
                const self = this
                this.targetImage = image
                this.registeredTags = []
                this.targetImage.tags.forEach(function(tag){
                    self.registeredTags.push(tag)
                })
                this.isView = true
                this.editTag = ""
            }
        }
    }
</script>
